/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  CheckCircleFilled,
  CloseCircleOutlined,
  ExportOutlined,
  HourglassOutlined,
  HourglassTwoTone,
  LoadingOutlined,
  // MonitorOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  SettingOutlined,
  SyncOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import {
  Alert,
  Badge,
  Button,
  Divider,
  message,
  Modal,
  Tabs,
  Tag,
  Tooltip,
} from 'antd';
import AnimatedNumber from 'components/animatedNumber';
import BacklinksHistory from 'components/backlinksHistory';
// import BacklinksMonitoring from 'components/backlinksMonitoring';
import BrowseBacklinksOpportunities from 'components/browseBacklinksOpportunities';
import DomainRating from 'components/domainRating';
import DomainSettingsModal from 'components/domainSettingsModal';
import FastResponderBadge from 'components/fastResponderBadge';
import Header from 'components/header';
import InviteYourFriends from 'components/inviteYourFriends';
import KarmaIcon from 'components/karmaIcon';
import ModalPointsToAllocate from 'components/modalPointsToAllocate';
import Onboarding from 'components/onboarding/index.js';
import RemainingAvailableRequests from 'components/remainingAvailableRequests';
import { shareKarmaLinksModalFunction } from 'components/shareKarmaLinksModalFunction';
import WelcomePanel from 'components/welcomePanel';
import moment from 'moment';
import { useContext, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  deleteRejectedBacklink,
  getDetails,
  resumeDomain,
} from 'services/api/domains';
import { redeemPoints, sawOnboarding } from 'services/api/users';
import DomainContext from 'services/domainContext';
import ProfileContext from 'services/profileContext';
import styles from 'styles/dashboard.module.scss';
import { BUY_POINTS_URL, LOCAL_STORAGE } from 'utils/constants';

const Vignette = ({
  name,
  figure,
  featured = false,
  animate = false,
  extra,
}) => (
  <div
    className={`${styles.vignetteWrapper}${
      featured ? ` ${styles.vignetteFeatured}` : ''
    }`}
  >
    {extra && <div className={styles.extra}>{extra}</div>}
    <div className={styles.vignetteFigure}>
      {animate ? <AnimatedNumber value={figure} /> : figure}
    </div>
    <div className={styles.vignetteName}>{name}</div>
  </div>
);

const Dashboard = () => {
  const redeemHandledRef = useRef(false);
  const [forceOnboarding, setForceOnboarding] = useState(false);
  const [isInfoResponsivityOpen, setIsInfoResponsivityOpen] = useState(false);

  const [newDomainFlow, setNewDomainFlow] = useState(false);
  const { profile } = useContext(ProfileContext);
  const { domains, updateDomains } = useContext(DomainContext);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [domainDetailsLoading, setDomainDetailsLoading] = useState(false);
  const [domainDetails, setDomainDetails] = useState(null);
  const [settingsModalisOpen, setSettingsModalisOpen] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [showWelcomePanel, setShowWelcomePanel] = useState(false);
  const [tabQuery, setTabQuery] = useState('browse');
  const [searchParams, setSearchParams] = useSearchParams();
  const [loadingResume, setLoadingResume] = useState(false);

  const getDomainDetails = () => {
    setDomainDetailsLoading(true);
    return getDetails({ name: selectedDomain.name })
      .then(({ data }) => {
        const ddetails = {
          ...data,
          sentBacklinksCount: data.requests?.filter(
            (e) => e.status === 'DONE' && e.from === data._id
          ).length,
          reveals: domains.find((d) => d.name === data.name)?.reveals,
        };
        setDomainDetails(ddetails);
        const currentDomainNotSetup =
          data?.status === 'TO_REVIEW' ||
          data?.status === 'TO_RE_REVIEW' ||
          !data.verified;

        const isNotTheFirstDomain = domains?.length > 1;

        if (currentDomainNotSetup && isNotTheFirstDomain) {
          localStorage.setItem(
            LOCAL_STORAGE.CURRENT_DOMAIN_VALIDATION,
            data.name
          );
          setNewDomainFlow(true);
        } else if (currentDomainNotSetup) {
          localStorage.setItem(
            LOCAL_STORAGE.CURRENT_DOMAIN_VALIDATION,
            data.name
          );
          // setForceOnboarding(true);
          return ddetails;
        }
      })
      .catch((e) => {
        console.error(e);
        message.error('Error while loading domain details');
      })
      .finally(() => {
        setDomainDetailsLoading(false);
      });
  };

  const openNewDomainFlow = () => {
    setNewDomainFlow(false);
    localStorage.removeItem(LOCAL_STORAGE.CURRENT_DOMAIN_VALIDATION);
    setTimeout(() => {
      //reset localstorage
      setNewDomainFlow(true);
    });
  };

  useEffect(() => {
    const profileNotValidated =
      !profile?.emailVerified || !profile?.linkedinProfile;

    const noDomainsVerified =
      domains?.filter(
        (d) => d.status !== 'TO_REVIEW' && d.status !== 'TO_RE_REVIEW'
      )?.length === 0;

    const noDomain = !domains || domains.length === 0 || noDomainsVerified;

    setTimeout(() => {
      setForceOnboarding(profileNotValidated || noDomain);
    }, 500);

    // test if current selected domain is in the list of domains, if not, select the first one
    if (
      domains &&
      domains.length > 0 &&
      selectedDomain &&
      !domains.find((d) => d.name === selectedDomain.name)
    ) {
      setSelectedDomain(domains[0]);
    }
  }, [domains]);

  useEffect(() => {
    const domainQuery = searchParams.get('domain');
    const domainQuerySelect =
      domainQuery && domainQuery.length > 0
        ? domains?.find((d) => d.name === domainQuery)
        : null;
    const firstDomain = domains && domains.length > 0 ? domains[0] : null;
    setSelectedDomain(domainQuerySelect || firstDomain);
    const tabQueryParam = searchParams.get('tab');
    if (tabQueryParam && tabQueryParam.length > 0) {
      if (tabQueryParam === 'received') {
        setTabQuery('history');
      } else {
        setTabQuery(tabQueryParam);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    const action = searchParams.get('action');
    const domain = searchParams.get('domain');

    if (action === 'redeem' && domain && !redeemHandledRef.current) {
      redeemHandledRef.current = true;
      redeemPoints(domain)
        .then(({ data }) => {
          if (data.pointsRedeemed) {
            message.success("You've received 50 points!");
          } else {
            message.info('Points already redeemed');
          }
        })
        .catch((e) => {
          if (e.response?.data?.error === 'DOMAIN_NOT_FOUND') {
            message.error('Domain not found');
          } else {
            message.error('Failed to redeem points');
          }
        })
        .finally(() => {
          setSearchParams((prev) => {
            prev.delete('action');
            return prev;
          });
        });
    }
  }, []);

  useEffect(() => {
    if (selectedDomain && selectedDomain.name) {
      getDomainDetails();
    }
  }, [selectedDomain]);

  useEffect(() => {
    setShowWelcomePanel(!profile.hasSeenOnboarding);
  }, [profile]);

  const closeOnboarding = () => {
    setShowWelcomePanel(false);
    sawOnboarding().catch((e) => {
      console.error(e);
    });
  };

  useEffect(() => {
    const isInfoResponse = localStorage.getItem(
      LOCAL_STORAGE.INFO_RESPONSIVITY
    );
    if (isInfoResponse && isInfoResponse.length > 0) {
      setIsInfoResponsivityOpen(isInfoResponse === 'true');
    } else {
      setIsInfoResponsivityOpen(true);
    }
  }, []);

  const openSettingsModal = () => setSettingsModalisOpen(true);
  const closeSettingsModal = () => setSettingsModalisOpen(false);

  const getDomainStatusIcon = (domain, status) => {
    if (!domain.live) {
      return <PauseCircleOutlined style={{ marginRight: 4 }} />;
    }
    switch (status) {
      default:
      case 'TO_RE_REVIEW':
      case 'TO_REVIEW':
        return (
          <HourglassOutlined
            twoToneColor="#051200"
            className={styles.iconStatus}
          />
        );
      case 'APPROVED':
        return <CheckCircleFilled className={styles.iconStatus} />;
      case 'REJECTED':
      case 'BANNED':
        return <CloseCircleOutlined className={styles.iconStatus} />;
    }
  };

  const removeDomain = () => {
    setRemoveLoading(true);
    deleteRejectedBacklink({ name: domainDetails.name })
      .then(() => {
        //list domains
        //select first one
        return updateDomains().then(() => {
          setSelectedDomain(domains.length > 0 ? domains[0] : null);
        });
      })
      .catch((e) => {
        console.error(e);
        message.error('Error while deleting domain, please try again');
      })
      .finally(() => {
        setRemoveLoading(false);
      });
  };

  const onChangeTab = (activekey) => {
    setSearchParams((prev) => {
      prev.set('tab', activekey);
      return prev;
    });
  };

  const resumeDomainFunction = () => {
    if (loadingResume) {
      return;
    }
    setLoadingResume(true);
    resumeDomain({
      name: domainDetails.name,
    })
      .then(() => {
        message.success(`${domainDetails.name} was resumed successfully`);
        updateDomains();
        return getDomainDetails();
      })
      .catch((e) => {
        console.error(e);
        message.error(
          'There was a problem when trying to resume the domain, please refresh your page an try again.'
        );
      })
      .finally(() => {
        setLoadingResume(false);
      });
  };

  const getRejectionText = () => {
    switch (domainDetails.rejectionDetails.reason) {
      default:
      case 'DOMAIN_ALREADY_EXISTS':
        return 'This domain has already been registered on KarmaLinks';
      case 'LOWER_THAN_MIN_DR':
        return 'Your domain rating is too low to enter KarmaLinks for now';
      case 'FORBIDDEN_CATEGORY':
        return 'This category is not authorized on KarmaLinks';
      case 'OTHER':
        return 'This domain was not approved by KarmaLinks';
    }
  };
  const closeInfoResposivity = () => {
    setIsInfoResponsivityOpen(false);
    localStorage.setItem(LOCAL_STORAGE.INFO_RESPONSIVITY, false);
  };

  const hasAtLeastOneDomainApproved =
    domains?.filter((d) => d.status === 'APPROVED').length > 0;

  const pendingRequests = domainDetails?.requests?.filter(
    (e) =>
      (e.status === 'PENDING' && e.initiatedBy !== domainDetails._id) ||
      (e.status === 'ACCEPTED' && e.from === domainDetails._id)
  );

  return (
    <div
      className={`${
        showWelcomePanel && hasAtLeastOneDomainApproved
          ? ` ${styles.welcomePanelWrapper}`
          : ''
      }`}
    >
      {showWelcomePanel && hasAtLeastOneDomainApproved && (
        <WelcomePanel close={closeOnboarding} />
      )}
      <Header />
      <>
        <div className={`${styles.wrapper}`}>
          <div className={styles.inner}>
            <InviteYourFriends />
            <ModalPointsToAllocate />
            <div className={styles.domainsTitle}>
              {`Domains${
                domains && domains.length > 0 ? ` (${domains.length})` : ''
              }`}
            </div>
            <div className={styles.domainsListWrapper}>
              {domains?.map((d) => {
                const numberRequestPending = d?.requests?.filter(
                  (e) =>
                    (e.status === 'PENDING' && e.initiatedBy !== d._id) ||
                    (e.status === 'ACCEPTED' && e.from === d._id)
                ).length;

                return (
                  <Badge
                    count={numberRequestPending}
                    key={d._id}
                    offset={[-18, 3]}
                  >
                    <Tag
                      onClick={() => {
                        setSearchParams((prev) => {
                          prev.set('domain', d.name);
                          prev.delete('onlyYC');
                          prev.delete('categories');
                          prev.delete('onlyGoodMatch');
                          prev.delete('onlyAvailable');
                          return prev;
                        });
                      }}
                      color={
                        d.status === 'TO_REVIEW' || d.status === 'TO_RE_REVIEW'
                          ? ''
                          : d.status === 'REJECTED' || d.status === 'BANNED'
                          ? 'red'
                          : 'green'
                      }
                      className={`${styles.domainTag} ${
                        selectedDomain?._id === d._id ? styles.selectedTag : ''
                      }${
                        d.status === 'TO_REVIEW' || d.status === 'TO_RE_REVIEW'
                          ? ` ${styles.domainNotLive}`
                          : ''
                      }${
                        d.status === 'REJECTED' || d.status === 'BANNED'
                          ? ` ${styles.domainRejected}`
                          : ''
                      }`}
                      key={d._id}
                    >
                      {selectedDomain?._id === d._id && domainDetailsLoading ? (
                        <LoadingOutlined spin style={{ marginRight: 4 }} />
                      ) : (
                        getDomainStatusIcon(d, d.status)
                      )}
                      {d.name}
                      {d.isYC && (
                        <img
                          src="/img/yc.png"
                          alt="ycombinator"
                          className={styles.ycLogoDomainName}
                        />
                      )}
                      {d.status === 'APPROVED' && d.verified && (
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Divider
                            type="vertical"
                            style={{
                              borderColor: '#00000024',
                              height: '1.3em',
                              marginLeft: 0,
                              marginRight: '6px',
                            }}
                          />
                          {d.points}&nbsp;
                          <KarmaIcon />
                        </span>
                      )}
                    </Tag>
                  </Badge>
                );
              })}
              <Tag
                color="blue"
                className={`${styles.domainTag} ${styles.domainTagAdd}`}
                key={'add'}
                onClick={openNewDomainFlow}
              >
                <PlusCircleOutlined />
                &nbsp;Add a domain
              </Tag>
            </div>
            {domainDetails && (
              <div className={styles.detailsWrapper}>
                {domainDetails.dr < 5 ? (
                  <div>
                    <Alert
                      message="Domain Rating too low"
                      description={
                        <div>
                          Your domain rating is too low to participate (lower
                          than 5).
                          <br />
                          <br />
                          The good news is that we have a solution for you!
                          <br />
                          <br />
                          <b>
                            Use Uneed Directories to automatically grow your DR
                            above 5 and start using KarmaLinks
                          </b>
                          <div>
                            <a
                              href="https://uneed-directories.com/?ref=karmalinks"
                              target={'_blank'}
                              rel="noreferrer"
                            >
                              <Button
                                size="large"
                                type="primary"
                                style={{ marginTop: 14 }}
                              >
                                Go to Uneed Directories
                              </Button>
                            </a>
                          </div>
                        </div>
                      }
                      type="warning"
                      showIcon
                    />
                  </div>
                ) : (
                  <>
                    {!domainDetails.live && (
                      <Alert
                        message="Domain is paused"
                        description={
                          <div>
                            Your domain can't receive backlinks right now and
                            you can't ask backlinks either.
                          </div>
                        }
                        type="warning"
                        icon={<PauseCircleOutlined />}
                        showIcon
                        style={{ border: 'none', marginBottom: 12 }}
                        action={
                          <Button
                            size="small"
                            type="primary"
                            loading={loadingResume}
                            onClick={() => {
                              resumeDomainFunction();
                            }}
                            icon={<PlayCircleOutlined />}
                          >
                            Resume domain
                          </Button>
                        }
                      />
                    )}
                    {domainDetails.status !== 'REJECTED' &&
                      domainDetails.status !== 'BANNED' && (
                        <div className={styles.settingsContainer}>
                          <div className={styles.settingsWrapper}>
                            {domainDetails.isFastResponder && (
                              <div>
                                <Tooltip title="You are a fast responder. Others can see your badge on your domain details. You're more likely to receive requests now.">
                                  <FastResponderBadge
                                    style={{ marginRight: 12 }}
                                  />
                                  &nbsp;
                                </Tooltip>
                              </div>
                            )}
                            {domainDetails.live && (
                              <RemainingAvailableRequests
                                pendingGiveRequestsCount={
                                  domainDetails.pendingGiveRequestsCount
                                }
                              />
                            )}
                            <div>
                              <Button
                                type="link"
                                onClick={openSettingsModal}
                                icon={<SettingOutlined />}
                              >
                                {`Settings for ${domainDetails.name}`}
                              </Button>
                            </div>
                          </div>
                        </div>
                      )}

                    {(domainDetails.status === 'TO_REVIEW' ||
                      domainDetails.status === 'TO_RE_REVIEW') && (
                      <div className={styles.inReviewWrapper}>
                        <div className={styles.inReviewInner}>
                          <HourglassTwoTone
                            twoToneColor={'#564e99'}
                            className={styles.inReviewIcon}
                          />
                          {domainDetails.verified ? (
                            <h2>We're currently reviewing this domain</h2>
                          ) : (
                            <h2>This domain is not yet verified</h2>
                          )}
                        </div>
                      </div>
                    )}
                    {domainDetails.status === 'REJECTED' && (
                      <>
                        <div className={styles.rejectedWrapper}>
                          <div className={styles.rejectedInner}>
                            <div style={{ flex: 1 }}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                }}
                              >
                                <CloseCircleOutlined
                                  twoToneColor={'red'}
                                  className={styles.rejectedIcon}
                                />
                                <div style={{ flexGrow: 1 }}>
                                  <h2>{getRejectionText()}</h2>
                                  <p>The domain has been rejected.</p>
                                </div>
                              </div>
                            </div>

                            <div className={styles.rejectedCta}>
                              <Button
                                onClick={removeDomain}
                                loading={removeLoading}
                              >
                                Remove Domain
                              </Button>
                            </div>
                          </div>
                        </div>
                        {domainDetails.rejectionDetails?.reason ===
                          'LOWER_THAN_MIN_DR' && (
                          <div style={{ marginTop: 24 }}>
                            For KarmaLinks to be effective, a minimum domain rating is needed. This ensures every member gets quality traffic from each backlink posted to the community. If you don't have another domain and this is a new website, consider increasing your domain rating first.                                                  
                            <div
                              style={{
                                marginTop: 12,
                                padding: '12px 18px',
                                background: '#fffbe6',
                                borderRadius: 10,
                                color: '#614700',
                              }}
                            >
                              New website? Increase your domain rating by listing your site with{' '}
                              <a
                                href="https://gumroad.com/a/804365715"
                                rel="noreferrer noopener"
                                target="_blank"
                              >
                                Boringlaunch
                              </a>{' '}                             
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {domainDetails.status === 'BANNED' && (
                      <div className={styles.rejectedWrapper}>
                        <div className={styles.rejectedInner}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                            }}
                          >
                            <CloseCircleOutlined
                              twoToneColor={'red'}
                              className={styles.rejectedIcon}
                            />
                            <div style={{ flexGrow: 1 }}>
                              <h2>
                                This domain has been banned from KarmaLinks
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {domainDetails.status === 'APPROVED' && (
                      <div>
                        {!domainDetails.isFastResponder &&
                          isInfoResponsivityOpen && (
                            <div>
                              <Alert
                                style={{
                                  background: '#fffbe3',
                                  border: '1px solid #e9e4c5',
                                }}
                                closable
                                onClose={() => {
                                  closeInfoResposivity();
                                }}
                                message={
                                  <div>
                                    <FastResponderBadge
                                      style={{ marginRight: 12 }}
                                    />
                                    <b>Fast Responder Badge</b> Reply within 48
                                    hours to earn this badge and get 70% more
                                    backlinks.
                                  </div>
                                }
                              />
                            </div>
                          )}
                        <div className={styles.vignetteList}>
                          <Vignette
                            animate
                            figure={domainDetails.points}
                            name={
                              <span>
                                Karma Points&nbsp;
                                <KarmaIcon />
                              </span>
                            }
                            featured
                            extra={
                              <div>
                                <Button
                                  icon={<PlusCircleOutlined />}
                                  style={{ padding: 0, paddingRight: 12 }}
                                  type="link"
                                  onClick={() => {
                                    Modal.info({
                                      okButtonProps: { type: 'link' },
                                      width: 460,
                                      icon: null,
                                      closable: true,
                                      footer: null,
                                      title: 'Get more points',
                                      content: (
                                        <div>
                                          <div>
                                            <div className={styles.step}>
                                              <div className={styles.stepTitle}>
                                                1. Give backlinks
                                              </div>
                                              <div
                                                className={
                                                  styles.stepDescription
                                                }
                                              >
                                                Explore available opportunities
                                                in the{' '}
                                                <b>
                                                  Browse baclinks Opportunities
                                                </b>{' '}
                                                tab and click <b>Give</b> to
                                                earn Karma Points <KarmaIcon />
                                              </div>
                                            </div>
                                            <div className={styles.step}>
                                              <div className={styles.stepTitle}>
                                                2. Share on Linkedin
                                              </div>
                                              <div
                                                className={
                                                  styles.stepDescription
                                                }
                                              >
                                                Get 10 <KarmaIcon /> Karma
                                                Points for every person who
                                                signs up using your unique
                                                referral link.
                                                <Button
                                                  type="link"
                                                  style={{
                                                    fontWeight: 'bold',
                                                  }}
                                                  onClick={() =>
                                                    shareKarmaLinksModalFunction(
                                                      profile.inviteCode
                                                    )
                                                  }
                                                >
                                                  Learn more
                                                </Button>
                                              </div>
                                            </div>
                                            <div className={styles.step}>
                                              <div className={styles.stepTitle}>
                                                3. Purchase points
                                              </div>
                                              <div
                                                className={
                                                  styles.stepDescription
                                                }
                                              >
                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    justifyContent:
                                                      'space-between',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  <div>
                                                    Need more points instantly?{' '}
                                                  </div>
                                                  <div>
                                                    <a
                                                      href={BUY_POINTS_URL}
                                                      rel="noreferrer noopener"
                                                      target="_blank"
                                                    >
                                                      <Button
                                                        type="primary"
                                                        style={{
                                                          color: 'white',
                                                        }}
                                                      >
                                                        <ExportOutlined />
                                                        &nbsp;Purchase points
                                                      </Button>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ),
                                    });
                                  }}
                                >
                                  Get more points
                                </Button>
                              </div>
                            }
                          />
                          {domainDetails.metrics && (
                            <Vignette
                              figure={
                                <DomainRating
                                  value={domainDetails.metrics?.authority?.dr}
                                />
                              }
                              name={'Domain Rating'}
                              extra={
                                domainDetails.metrics.date ? (
                                  <Tooltip title="The domain rating is updated automatically.">
                                    <div className={styles.domainRatingExtra}>
                                      <SyncOutlined />
                                      &nbsp;
                                      {`Synced on  ${moment(
                                        domainDetails.metrics.date
                                      ).format('Do MMM YYYY')}`}
                                    </div>
                                  </Tooltip>
                                ) : (
                                  <></>
                                )
                              }
                            />
                          )}
                          <Vignette
                            figure={domainDetails?.receivedBacklinksCount || 0}
                            name={`Received Backlinks (${
                              domainDetails?.sentBacklinksCount || 0
                            } sent)`}
                          />
                        </div>
                        <div>
                          <Tabs
                            onChange={onChangeTab}
                            activeKey={tabQuery}
                            items={[
                              domainDetails.live
                                ? {
                                    key: 'browse',
                                    label: `Browse backlinks opportunities`,
                                    children: (
                                      <BrowseBacklinksOpportunities
                                        domain={domainDetails}
                                        refreshDomainDetails={getDomainDetails}
                                      />
                                    ),
                                    icon: <SearchOutlined />,
                                  }
                                : {},
                              {
                                key: 'history',
                                label:
                                  pendingRequests.length > 0 ? (
                                    <Badge
                                      count={pendingRequests.length}
                                      offset={[0, -5]}
                                    >
                                      History of requests and backlinks
                                    </Badge>
                                  ) : (
                                    'History of requests and backlinks'
                                  ),
                                children: (
                                  <BacklinksHistory
                                    domain={domainDetails}
                                    refreshDomainDetails={getDomainDetails}
                                  />
                                ),
                                icon: <UnorderedListOutlined />,
                              },
                              // {
                              //   key: 'monitoring',
                              //   label: `Backlinks Monitoring`,
                              //   children: <BacklinksMonitoring />,
                              //   icon: <MonitorOutlined />,
                              // },
                            ]}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
        {(forceOnboarding || newDomainFlow) && (
          <Onboarding
            firstOnboarding={forceOnboarding}
            close={
              newDomainFlow
                ? () => {
                    localStorage.removeItem(
                      LOCAL_STORAGE.CURRENT_DOMAIN_VALIDATION
                    );
                    setNewDomainFlow(false);
                  }
                : () => {}
            }
          />
        )}
        {domainDetails && settingsModalisOpen && (
          <DomainSettingsModal
            isOpen={settingsModalisOpen}
            onClose={closeSettingsModal}
            domain={domainDetails}
            getDomainDetails={getDomainDetails}
          />
        )}
      </>
    </div>
  );
};

export default Dashboard;
